import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PaymentWizardDialogComponent } from '@app/account/finance-page/components/payment-wizard-dialog/payment-wizard-dialog.component';
import { CollectionCardModule } from '@app/collections';
import { BreadcrumbsModule } from '@app/core/components/breadcrumbs/breadcrumbs.module';
import { MainHeaderModule } from '@app/core/components/main-header/main-header.module';
import { MeetingFormWrapperModule } from '@app/core/components/meeting-form-wrapper/meeting-form-wrapper.module';
import { MobileModalModule } from '@app/core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@app/core/components/modal/modal.module';
import { MeetingPageModule } from '@app/meetings/meeting-page/meeting-page.module';
import { MeetingsFormService } from '@app/meetings/meetings-form.service';
import { SchoolFormModule } from '@app/school-settings/school-form/school-form.module';
import { ContentNotFoundModule, ProfileFillCardModule } from '@app/shared';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { StickyModule } from '@core/components/sticky/sticky.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { InViewportModule } from 'ng-in-viewport';
import { OnUiButtonModule } from 'onclass-ui';
import { ContentPageComponent } from '../content-page.component';
import { LibraryHeaderComponent } from '../headers/library-header/library-header.component';
import { LibraryHeaderNewComponent } from '../headers/library-header-new/library-header-new.component';
import { CollectionPageComponent } from './collection-page/collection-page.component';
import { FilterCleaningComponent } from './filter-cleaning/filter-cleaning.component';
import { PaneComponent, PaneContainerDirective } from './pane/pane.component';
import { PanesComponent } from './panes/panes.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ModalModule,
    MobileModalModule,
    BreadcrumbsModule,
    MainHeaderModule,
    FormsModule,
    MeetingPageModule,
    StickyModule,
    OnUiButtonModule,
    MeetingFormWrapperModule,
    SchoolFormModule,
    CollectionCardModule,
    ContentNotFoundModule,
    InViewportModule,
    SpinnersModule,
    PaymentWizardDialogComponent,
    ProfileFillCardModule,
    IconComponent,
  ],
  exports: [PaneComponent, PanesComponent, LibraryHeaderComponent, LibraryHeaderNewComponent, FilterCleaningComponent],
  declarations: [
    PaneComponent,
    PanesComponent,
    PaneContainerDirective,
    ContentPageComponent,
    FilterCleaningComponent,
    /** Headers */
    LibraryHeaderComponent,
    LibraryHeaderNewComponent,
    /** Pages */
    CollectionPageComponent,
  ],
  providers: [MeetingsFormService],
})
export class LibraryPanesModule {}
